import React from 'react';
import BaseList from 'components/lists/BaseList';
import { useAccessLog } from 'hooks/logs';

function ListEquipmentMobileOperator(props) {
  useAccessLog('Acesso ao cadastro de operadoras');
  const { match } = props;
  return (
    <BaseList
      columns={[
        { value: row => row.name, label: 'Nome', sort: 'name' },
      ]}
      genericSearchFields={[
        { label: 'Nome', name: 'name' },
      ]}
      basePath="equipment-mobile-operator"
      title="Lista de Operadoras"
      addButtonText="Cadastrar Operadora"
      addUrl={`${match.path}/novo`}
    />
  );
}

export default ListEquipmentMobileOperator;
